<template>
  <HeroSection />
  <WorkbenchTeaserSection />
  <PillarsSection />
  <BuildForSection />
  <OurTeamSection />
  <CaseStudiesSection />
  <BlogSection />
  <ClosingCtaSection />
</template>

<script setup lang="ts">
import HeroSection from '@/views/home/HeroSection.vue'
import WorkbenchTeaserSection from '@/views/home/WorkbenchTeaserSection.vue'
import PillarsSection from '@/views/home/PillarsSection.vue'
import BuildForSection from '@/views/home/BuildForSection.vue'
import OurTeamSection from '@/views/home/OurTeamSection.vue'
import CaseStudiesSection from '@/views/home/CaseStudiesSection.vue'
import BlogSection from '@/views/home/BlogSection.vue'
import ClosingCtaSection from '@/views/home/ClosingCtaSection.vue'
import { usePageSeo } from '@/composables/Meta'

usePageSeo('home')
</script>
